export interface IStorageAccessor {
  getItem(key?: string): any;

  setItem(value: string, key?: string): void;

  removeItem(key?: string): void;
}

class WindowStorage {
  constructor() {
    if (typeof window !== "undefined") {
      if (window.storage == undefined) {
        window.storage = {};
      }
    }
  }

  setItem(key: string, item: any) {
    window.storage[key] = item;
  }

  getItem(key: string) {
    return window.storage[key];
  }

  removeItem(key: string) {
    this.setItem(key, undefined);
  }
}

export class StorageAccessor implements IStorageAccessor {
  private readonly storage;

  constructor() {
    if (typeof window !== "undefined") {
      this.storage = new WindowStorage();
    }
  }

  public getItem(key = "BookingTemp"): any {
    return this.storage && this.storage.getItem(key);
  }

  public setItem(value: string, key = "BookingTemp"): void {
    this.storage && this.storage.setItem(key, value);
  }

  public removeItem = (key = "BookingTemp"): void => {
    this.storage && this.storage.removeItem(key);
  };
}
